<template>
    <div class="flex flex-column sm:flex-row mx-auto ks_cluster_page_waiter__content">
        <template v-if="errorMessage">
            <AdaptersMessage :message="errorMessage" class="w-full" />
        </template>
        <template v-else>
            <div class="page_waiter__loader">
                <AdaptersLoader :loading="true" type="static" />
            </div>
            <div class="flex flex-column justify-content-center gap-5 py-3 w-full">
                <div class="flex flex-column gap-2">
                    <span v-html="$t('lang.cluster.page_waiting.main_text')" />
                </div>
                <div>
                    <template v-if="countSteps === 2">
                        <Stepper :linear="true" :activeStep="activeStepIndex" :pt="{
                            nav: {style: 'max-width: 150px;'},
                            panelcontainer: {class: 'pl-0'}
                        }">
                            <StepperPanel :pt="{
                                separator: {class: 'm-0'}
                            }">
                                <template #content>
                                    <span class="text-color-secondary text-sm">
                                        {{ $t('lang.cluster.page_waiting.step_parsing_label') }}
                                    </span>
                                </template>
                            </StepperPanel>
                            <StepperPanel :pt="{
                                separator: {class: 'm-0'}
                            }">
                                <template #content>
                                    <span class="text-color-secondary text-sm">
                                        {{ $t('lang.cluster.page_waiting.step_clustering_label') }}
                                    </span>
                                </template>
                            </StepperPanel>
                        </Stepper>
                    </template>
                    <ProgressBar :value="progress" />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import AdaptersLoader from "../../../component/adapters/Loader.vue";
import ClusterApi from "../../../api/ClusterApi";
import {AppConstant} from "../../../app.constant";
import Alerts from "../../../mixins/Alerts";
import ProgressBar from "primevue/progressbar";
import AdaptersMessage from "../../../component/adapters/Message.vue";
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";

export default {
    name: "KSClusterPageWaiter",
    mixins: [Alerts],
    data() {
        return {
            errorMessage: null,
            activeStepIndex: 0,
            progress: 0,
        }
    },
    props: {
        uid: {
            type: String,
            required: true,
        },
        countSteps: {
            type: Number,
            required: true,
        }
    },
    mounted() {
        if (this.countSteps === 1) {
            this.checkClusterState()
        } else {
            this.checkParsersState();
        }
    },
    methods: {
        checkParsersState() {
            ClusterApi
                .getParsersState(this.uid)
                .then(response => {
                    if (response.batches_total === 0) {
                        this.activeStepIndex = 1;
                        this.checkClusterState();
                        return;
                    }

                    this.progress = response.batches_total > 0
                        ? ((100 * response.batches) / response.batches_total).toFixed()
                        // еще не получили общее кол-во батчей
                        : 0;

                    setTimeout(() => this.checkParsersState(), AppConstant.TIMEOUT_WAITER_REQUEST);
                })
                .catch(error => this.errorMessage = error.message);
        },
        checkClusterState() {
            ClusterApi
                .getClusterState(this.uid)
                .then(response => {
                    if (response.state === 10) {
                        window.location.reload();
                    }

                    this.progress = response.progress;

                    setTimeout(() => this.checkClusterState(), AppConstant.TIMEOUT_WAITER_REQUEST);
                })
                .catch(error => this.errorMessage = error.message);
        }
    },
    components: {
        AdaptersMessage,
        ProgressBar,
        AdaptersLoader,
        Stepper,
        StepperPanel,
    }
}
</script>

<style scoped>
.ks_cluster_page_waiter__content {
    max-width: var(--keysso-max-width-content-normal);
    padding: 0 15px;
}
</style>
